// Navbar.js
import React, { useEffect } from 'react';
import { useOktaAuth } from '@okta/okta-react';
import { useNavigate, Link } from 'react-router-dom';
import { Container, Image, Menu } from 'semantic-ui-react';
import pmLogo from '../images/logo.png';

const Navbar = ({ setCorsErrorModalOpen }) => {
  const navigate = useNavigate();
  const { authState, oktaAuth } = useOktaAuth();

  // Effect to handle redirect after login
  useEffect(() => {
    if (authState && authState.isAuthenticated) {
     // Only redirect if not already on a protected route
    //  const publicPaths = ['/', '/login'];
    //   if (publicPaths.includes(history.location.pathname)) {
    //     history.push('/'); // Use replace to avoid adding extra entries to history stack
    //   }
    }
  }, [authState, navigate]);

  // Check if error is a CORS error
  const isCorsError = (err) =>
    err.name === 'AuthApiError' && !err.errorCode && err.xhr.message === 'Failed to fetch';

  // Handle login with Okta
  const login = async () => {
    await oktaAuth.signInWithRedirect();
  };

  // Handle logout with Okta and redirection
  const logout = async () => {
    const basename = window.location.origin; // Directly use window.location.origin
    try {
      await oktaAuth.signOut({ postLogoutRedirectUri: basename });
    } catch (err) {
      if (isCorsError(err)) {
        setCorsErrorModalOpen(true);
      } else {
        console.error('Logout Error:', err);
      }
    }
  };

  // Return nothing if auth state is not yet determined
  if (!authState) {
    return null;
  }

  return (
    <div>
      <Menu fixed="top" inverted>
        <Container>
          <Menu.Item header>
            <Image size="mini" src={pmLogo} />
            <Link to="/tests">Automation Hub</Link>
          </Menu.Item>

          <Menu.Menu position="right">
            {authState.isAuthenticated ? (
              <Menu.Item id="logout-button" onClick={logout}>
                Okta
                <br />
                Logout
              </Menu.Item>
            ) : (
              <Menu.Item onClick={login}>
                Okta
                <br />
                Login
              </Menu.Item>
            )}
          </Menu.Menu>
        </Container>
      </Menu>
    </div>
  );
};

export default Navbar;
